import { ModeAction } from "state/enum";

export const useButtonModeRPkg = props => {
  const {
    mode,
    rows,
    stateButton: { setEditBtn, setAddBtn, setDeleteBtn },
    modeOfWDN95031,
    containerType,
  } = props;
  if ([ModeAction.VIEW, ModeAction.SELECTED].includes(modeOfWDN95031) || containerType === "A") {
    setAddBtn(true);
    setEditBtn(true);
    setDeleteBtn(true);
    return;
  }
  // check record of WDN95031
  if (!rows?.length) {
    setAddBtn(false);
    setEditBtn(true);
    setDeleteBtn(true);
    return;
  }
  switch (mode) {
    case ModeAction.VIEW:
      setAddBtn(false);
      setEditBtn(true);
      setDeleteBtn(true);
      break;
    case ModeAction.ADD:
      setAddBtn(true);
      setEditBtn(true);
      setDeleteBtn(true);
      break;
    case ModeAction.COPY:
      setAddBtn(true);
      setEditBtn(true);
      setDeleteBtn(true);
      break;
    case ModeAction.EDIT:
      setAddBtn(true);
      setEditBtn(true);
      setDeleteBtn(true);
      break;
    case ModeAction.SELECTED:
      setAddBtn(false);
      setEditBtn(false);
      setDeleteBtn(false);
      break;

    default:
      break;
  }
};
